/* Pulse upsell slider — index-based carousel for the add-to-cart upsell popup.
   Uses pure event delegation so it works regardless of when the popup is
   injected into the DOM (the popup is fetched via AJAX and inserted via
   innerHTML, which means inline <script> tags inside it would NOT execute —
   that's why the previous in-section script never ran).

   Markup contract (rendered by sections/product-popup-upsell.liquid):
     [data-pulse-upsell-slider]
       [data-pulse-slider-track]
         [data-pulse-slider-slide] x N
       [data-pulse-slider-prev]
       [data-pulse-slider-next]
       [data-pulse-slider-dot="N"] x N
*/
(function () {
  'use strict';

  function getCount(slider) {
    return slider.querySelectorAll('[data-pulse-slider-slide]').length;
  }

  function getIndex(slider) {
    var i = parseInt(slider.dataset.pulseSliderIndex || '0', 10);
    return isNaN(i) ? 0 : i;
  }

  function go(slider, newIndex) {
    var max = getCount(slider) - 1;
    if (newIndex < 0) newIndex = 0;
    if (newIndex > max) newIndex = max;

    slider.dataset.pulseSliderIndex = newIndex;

    var track = slider.querySelector('[data-pulse-slider-track]');
    if (track) track.style.transform = 'translateX(' + (-newIndex * 100) + '%)';

    slider.querySelectorAll('[data-pulse-slider-dot]').forEach(function (dot) {
      var i = parseInt(dot.dataset.pulseSliderDot, 10);
      var active = i === newIndex;
      dot.classList.toggle('is-active', active);
      if (active) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });

    var prev = slider.querySelector('[data-pulse-slider-prev]');
    var next = slider.querySelector('[data-pulse-slider-next]');
    if (prev) prev.classList.toggle('is-disabled', newIndex === 0);
    if (next) next.classList.toggle('is-disabled', newIndex === max);
  }

  // Document-level click delegation — catches any arrow/dot click anywhere,
  // anytime, regardless of when the slider was added to the DOM.
  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-pulse-slider-prev]');
    var next = e.target.closest('[data-pulse-slider-next]');
    var dot  = e.target.closest('[data-pulse-slider-dot]');
    if (!prev && !next && !dot) return;

    var slider = (prev || next || dot).closest('[data-pulse-upsell-slider]');
    if (!slider) return;

    e.preventDefault();
    e.stopPropagation();

    if (prev) go(slider, getIndex(slider) - 1);
    else if (next) go(slider, getIndex(slider) + 1);
    else if (dot) go(slider, parseInt(dot.dataset.pulseSliderDot, 10));
  }, true);

  // Touch swipe — also delegated, no per-slider init required
  var swipeStart = null;
  document.addEventListener('touchstart', function (e) {
    var slider = e.target.closest('[data-pulse-upsell-slider]');
    if (!slider) return;
    if (!e.touches || !e.touches[0]) return;
    swipeStart = {
      x: e.touches[0].clientX,
      y: e.touches[0].clientY,
      slider: slider,
      vertical: false
    };
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (!swipeStart || !e.touches || !e.touches[0]) return;
    var dx = e.touches[0].clientX - swipeStart.x;
    var dy = e.touches[0].clientY - swipeStart.y;
    if (Math.abs(dy) > Math.abs(dx)) swipeStart.vertical = true;
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    if (!swipeStart || swipeStart.vertical) { swipeStart = null; return; }
    var endX = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0].clientX : swipeStart.x;
    var dx = endX - swipeStart.x;
    var threshold = 35;
    if (Math.abs(dx) >= threshold) {
      go(swipeStart.slider, getIndex(swipeStart.slider) + (dx < 0 ? 1 : -1));
    }
    swipeStart = null;
  }, { passive: true });

  // Initial transform setup — when a slider lands in the DOM (either at page
  // load or after AJAX injection), make sure index 0 is shown
  function initIfNeeded(scope) {
    (scope || document).querySelectorAll('[data-pulse-upsell-slider]').forEach(function (slider) {
      if (slider.__pulseInited) return;
      slider.__pulseInited = true;
      go(slider, 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initIfNeeded(); });
  } else {
    initIfNeeded();
  }

  // Watch for newly-injected sliders (the popup is added via innerHTML on
  // add-to-cart click and re-injected on every variant change).
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('[data-pulse-upsell-slider]')) initIfNeeded(node.parentElement);
        else if (node.querySelector && node.querySelector('[data-pulse-upsell-slider]')) initIfNeeded(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
